/*
  Bundle Tier Table — behaviour
  Drives the theme's own variant picker (so price, Add to Cart variant, URL,
  pickup availability etc. all update through Sense/Dawn's normal code path).
  Survives the theme re-rendering the product info on every variant change.
*/
(function () {
  'use strict';

  function init(container) {
    if (!container || container.dataset.bttInit === '1') return;
    container.dataset.bttInit = '1';

    var optionName = container.getAttribute('data-option-name') || 'Bundle';
    var section = container.closest('.shopify-section') || container;
    var autoSelectDone = false;

    function getPicker() {
      return document.querySelector('product-info variant-selects') || document.querySelector('variant-selects');
    }

    // Native inputs that belong to the bundle option (radio pills or a dropdown).
    function nativeInputs() {
      var picker = getPicker();
      if (!picker) return [];
      var out = [];
      picker.querySelectorAll('input[type="radio"]').forEach(function (el) {
        var n = (el.getAttribute('data-option-name') || '').trim();
        var nm = (el.name || '').trim();
        if (n === optionName || nm.indexOf(optionName + '-') === 0) out.push(el);
      });
      picker.querySelectorAll('select').forEach(function (el) {
        if ((el.name || '') === 'options[' + optionName + ']') out.push(el);
      });
      return out;
    }

    function currentValue() {
      var els = nativeInputs();
      for (var i = 0; i < els.length; i++) {
        var el = els[i];
        if (el.tagName === 'SELECT') return el.value;
        if (el.checked) return el.value;
      }
      return null;
    }

    function hideNative() {
      nativeInputs().forEach(function (el) {
        var wrap = el.closest('fieldset, .product-form__input');
        if (wrap && !wrap.classList.contains('btt-native-hidden')) wrap.classList.add('btt-native-hidden');
      });
    }

    // Keep the table directly after the variant picker (outside it, so the
    // theme's innerHTML swap on variant change never wipes it). If something
    // does detach it, we still hold the node and put it back.
    // Rendered as a block inside the product section: the theme places it, never move it.
    var isBlock = !!container.closest('product-info, .product__info-container');

    function place() {
      if (isBlock) return;
      var picker = getPicker();
      if (!picker || !picker.parentNode) return;
      if (picker.nextElementSibling === section) return;
      picker.parentNode.insertBefore(section, picker.nextSibling);
      section.classList.add('btt-placed');
    }

    function sync() {
      var val = currentValue();
      if (!val) return;
      container.querySelectorAll('[data-bundle-tier]').forEach(function (b) {
        var on = b.getAttribute('data-option-value') === val;
        b.classList.toggle('is-selected', on);
        b.setAttribute('aria-checked', on ? 'true' : 'false');
      });
    }

    function selectValue(val) {
      var els = nativeInputs();
      for (var i = 0; i < els.length; i++) {
        var el = els[i];
        if (el.tagName === 'SELECT') {
          if (el.value !== val) {
            el.value = val;
            el.dispatchEvent(new Event('change', { bubbles: true }));
          }
          return true;
        }
        if (el.value === val) {
          if (!el.checked) el.click(); // real click = theme's normal variant flow
          return true;
        }
      }
      return false;
    }

    function autoSelectPopular() {
      if (autoSelectDone) return;
      if (!getPicker()) return;
      autoSelectDone = true;
      // Respect deep links (Google Shopping / ads use ?variant=...)
      if (/[?&]variant=/.test(window.location.search)) return;
      var popular = container.querySelector('[data-bundle-tier].is-popular:not([disabled])');
      if (!popular) return;
      var val = popular.getAttribute('data-option-value');
      if (currentValue() !== val) selectValue(val);
    }

    container.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-bundle-tier]');
      if (!btn || btn.disabled) return;
      var val = btn.getAttribute('data-option-value');
      // Optimistic UI; sync() corrects it once the theme re-renders.
      container.querySelectorAll('[data-bundle-tier]').forEach(function (b) {
        var on = b === btn;
        b.classList.toggle('is-selected', on);
        b.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      selectValue(val);
    });

    // Arrow-key navigation for the radiogroup
    container.addEventListener('keydown', function (e) {
      if (['ArrowDown', 'ArrowRight', 'ArrowUp', 'ArrowLeft'].indexOf(e.key) === -1) return;
      var tiers = Array.prototype.slice.call(container.querySelectorAll('[data-bundle-tier]:not([disabled])'));
      var idx = tiers.indexOf(document.activeElement);
      if (idx === -1) return;
      e.preventDefault();
      var step = (e.key === 'ArrowDown' || e.key === 'ArrowRight') ? 1 : -1;
      var next = tiers[(idx + step + tiers.length) % tiers.length];
      next.focus();
      next.click();
    });

    function refresh() {
      place();
      hideNative();
      sync();
      autoSelectPopular();
    }

    var scheduled = false;
    function scheduleRefresh() {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () { scheduled = false; refresh(); });
    }

    var root = document.querySelector('product-info') || document.body;
    new MutationObserver(scheduleRefresh).observe(root, { childList: true, subtree: true });
    document.addEventListener('change', function (e) {
      if (e.target && e.target.closest && e.target.closest('variant-selects')) setTimeout(sync, 0);
    });

    refresh();
  }

  function boot() {
    document.querySelectorAll('[data-bundle-tier-table]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
